import { type FormEvent, Fragment, type FunctionComponent, useState } from 'react'

import { showAlert } from 'src/actions/alertsActions'
import { closeDrawers } from 'src/actions/drawerActions'

import api from 'src/constants/api'

import { type RootStateOrAny, useDispatch, useSelector } from 'react-redux'

import Button from '../Common/Button'
import Drawer from '../Common/Drawer'
import Input from '../Common/Input'
import Select from '../Common/Select'
import Submit from '../Common/Submit'
import TextArea from '../Common/TextArea'

/* quote categories */
const typeOptions = [
  {
    label: 'New Service Quote',
    value: 'New Service Quote'
  },
  {
    label: 'Existing Service Upgrade',
    value: 'Existing Service Upgrade'
  }
]

/* form names */
interface Forms extends HTMLCollectionOf<HTMLFormElement> {
  requestQuoteForm: HTMLFormElement
}

const RequestQuote: FunctionComponent = (): JSX.Element => {
  const [loading, setLoading] = useState(false)

  const dispatch = useDispatch()

  const account = useSelector((state: RootStateOrAny) => state.account)

  /* drawer actions */
  const Actions: FunctionComponent = (): JSX.Element => {
    return (
      <Fragment>
        <Button bordered onClick={() => dispatch(closeDrawers())}>
          Cancel
        </Button>
        <Submit variant="primary" form="requestQuoteForm" />
      </Fragment>
    )
  }

  const requestedQuote = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setLoading(true)

    const forms = document.forms as Forms
    const form = forms.requestQuoteForm
    const data = new FormData(form)

    const ticket = {
      contact_type: 'Provide',
      title: 'PROVIDE ' + data.get('type') + ': ' + data.get('title'),
      description: data.get('description'),
      category: 'Request'
    }

    api
      .post(`/servicenow/account/${account.id}/ticket`, ticket)
      .then((response) => {
        setLoading(false)
        dispatch(closeDrawers())
        dispatch(
          showAlert({
            type: 'success',
            message: response.data.number + ' created.',
            component: 'RequestQuote'
          })
        )
      })
      .catch((error) => {
        setLoading(false)
        dispatch(
          showAlert({
            type: 'error',
            message: 'We were unable to create your quote. Please try again.',
            component: 'RequestQuote',
            error
          })
        )
      })
  }

  return (
    <Drawer title={'Request Quote'} loading={loading} actions={<Actions />}>
      <form onSubmit={(e) => requestedQuote(e)} id="requestQuoteForm" className="flex flex-col gap-4">
        {/* type */}
        <Select name="type" label="Request Type" options={typeOptions} selected="New Service Quote" required />
        {/* title */}
        <Input type="text" name="title" label="Request title" required />
        {/* description */}
        <TextArea name="description" label="Please tell us about your request:" required />
      </form>
    </Drawer>
  )
}

export default RequestQuote
